"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8.007 1.022a.613.613 0 1 1 0 1.226.613.613 0 0 1 0-1.226Zm3.17.855c.393 0 .712.313.722.703h1.556c.172 0 .312.14.312.311v12.795c0 .172-.14.312-.312.312H4.222v-1.007h8.54V3.456H3.227v11.92h.003v.622h-.67a.312.312 0 0 1-.312-.312V2.891c0-.172.14-.31.312-.31h1.556a.72.72 0 0 1 .674-.699v-.005h1.603a1.635 1.635 0 1 1 3.23 0h1.555ZM4.89 7.147v-.99l6.235.017-.002.99-6.233-.017Zm0 1.66v.99l6.233.017.002-.99-6.235-.017Zm0 3.641v-.99l6.235.017-.002.99-6.233-.017Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12.024 1.534a.918.918 0 1 1 .001 1.836.918.918 0 0 1 0-1.836Zm4.756 1.282c.588 0 1.068.469 1.083 1.054h2.334c.259 0 .468.21.468.467v19.196a.467.467 0 0 1-.468.467H5.272v-1.114h14.273V5H4.509v18.065h.005V24h-.663a.467.467 0 0 1-.467-.467V4.337c0-.258.209-.467.467-.467h2.335a1.08 1.08 0 0 1 1.01-1.047v-.007h2.406a2.41 2.41 0 0 1-.03-.363 2.453 2.453 0 0 1 4.905 0c0 .123-.012.244-.03.363h2.333ZM6.865 9.92V8.882l10.32.017-.004 1.039L6.865 9.92Zm0 2.959v1.038l10.316.018.003-1.038-10.32-.018Zm0 5.036v-1.038l10.32.018-.004 1.038-10.316-.018Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M16.032 2.045a1.224 1.224 0 1 1 0 2.451 1.226 1.226 0 0 1 0-2.451Zm6.341 1.709c.784 0 1.424.626 1.444 1.406h3.112c.345 0 .623.28.623.623v25.594a.622.622 0 0 1-.623.623H7.03v-1.485h19.03V6.667H6.011v24.086h.007V32h-.884a.623.623 0 0 1-.623-.623V5.783c0-.344.28-.623.623-.623h3.114a1.44 1.44 0 0 1 1.346-1.396v-.01h3.208a3.214 3.214 0 0 1-.04-.484 3.27 3.27 0 0 1 6.54 0c0 .165-.016.326-.04.484h3.111Zm-13.22 9.472v-1.384l13.76.023-.006 1.385-13.755-.024Zm0 3.946v1.384l13.754.024.005-1.384-13.76-.024Zm0 6.714v-1.384l13.76.024-.006 1.384-13.755-.024Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M24.031 3.067a1.838 1.838 0 1 1 0 3.677 1.838 1.838 0 0 1 0-3.677Zm9.512 2.565c1.177 0 2.134.938 2.164 2.108h4.67c.517 0 .935.419.935.935v38.39a.935.935 0 0 1-.935.935h-29.85v-1.87h28.915V9.61H8.62v36.52h.038V48h-.973a.935.935 0 0 1-.935-.935V8.675c0-.516.419-.935.935-.935h4.67a2.16 2.16 0 0 1 2.019-2.094v-.014h4.811a4.952 4.952 0 0 1-.06-.726 4.906 4.906 0 0 1 9.811 0c0 .247-.024.488-.06.726h4.667ZM14.537 21.079v-1.87l18.988.033-.006 1.87-18.982-.033Zm0 6.03v1.869l18.982.032.006-1.87-18.988-.032Zm0 9.767v-1.869l18.988.032-.006 1.87-18.982-.032Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M32.041 4.09a2.45 2.45 0 1 1 0 4.902 2.45 2.45 0 0 1 0-4.902Zm12.683 3.419a2.887 2.887 0 0 1 2.886 2.811h6.226c.689 0 1.246.558 1.246 1.246v51.188c0 .688-.557 1.246-1.246 1.246h-39.8v-2.493H52.59V12.813H11.493v48.694h.05V64h-1.297A1.247 1.247 0 0 1 9 62.754V11.566c0-.688.558-1.246 1.246-1.246h6.227a2.88 2.88 0 0 1 2.692-2.792v-.02h6.415a6.602 6.602 0 0 1-.08-.967 6.54 6.54 0 1 1 13.082 0c0 .33-.033.65-.08.968h6.222ZM19.383 28.106v-2.493l25.317.043-.009 2.493-25.308-.043Zm0 8.038v2.493l25.308.043.008-2.493-25.316-.042Zm0 13.025v-2.493l25.317.043-.009 2.493-25.308-.043Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconChecklist = function IconChecklist(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Checklist' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Checklist"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconChecklist.sizes = [16, 24, 32, 48, 64];
IconChecklist.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconChecklist;
exports.default = _default;